export default __webpack_public_path__ + "static/media/kanipakam-temple-preloader.0a33acaf.gif";